// extracted by mini-css-extract-plugin
var _1 = "PdfViewerToolbarZoomTool-modulePdfViewerToolbarZoomTool__GDjcZ";
var _2 = "PdfViewerToolbarZoomTool-modulescaleButton__gxfD3 PdfViewerToolbarButton-modulePdfViewerToolbarButton__zwwEi";
export { _1 as "PdfViewerToolbarZoomTool", _2 as "scaleButton" }
